module.exports = __webpack_public_path__ + "static/media/five-pcs-box.8e7a6372.png";